<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.active" persistent width="700" scrollable>
      <v-card>
        <v-card-title class="headline">
          {{
            $t("components.miscellaneous.diagnosticsReports.diagnosticsReports")
          }}</v-card-title
        >
        <v-card-text class="mt-4">
          <v-list subheader two-line>
            <v-list-group
              v-for="(report, index) in reports"
              :key="index"
              v-model="report.active"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-avatar>
                  <v-icon> mdi-chart-box </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    >{{
                      $t("components.miscellaneous.diagnosticsReports.report")
                    }}
                    {{ $moment(report.created).format("YYYY-MM-DD") }}
                    <v-chip class="ml-2">{{
                      report.user
                    }}</v-chip></v-list-item-title
                  >

                  <v-list-item-subtitle v-if="!!report.completed">{{
                    $t("components.miscellaneous.diagnosticsReports.completed")
                  }}</v-list-item-subtitle>

                  <v-list-item-subtitle v-if="!!report.canceled">
                    {{
                      $t("components.miscellaneous.diagnosticsReports.canceled")
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </template>

              <div class="ml-7 mb-6">
                <div v-if="!!report.completed">
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.completedOn",
                        {
                          date: $moment(report.completed).format(
                            "YYYY-MM-DD  H:mm:ss"
                          ),
                        }
                      )
                    }}
                  </span>
                </div>

                <div v-if="report.json_content.profile !== null">
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.telematicsProfile",
                        {
                          profile: report.json_content.profile.name,
                        }
                      )
                    }}
                  </span>
                </div>

                <div
                  v-if="
                    report.json_content.installer_options !== null &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    report.json_content.installer_options.firmware_version !==
                      null &&
                    typeof report.json_content.installer_options
                      .firmware_version !== 'undefined'
                  "
                >
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.firmwareVersion",
                        {
                          fwVersion:
                            report.json_content.installer_options
                              .firmware_version,
                        }
                      )
                    }}
                  </span>
                </div>

                <div
                  v-if="
                    report.json_content.installer_options !== null &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    report.json_content.installer_options !== null
                  "
                  class="mb-2"
                >
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.installerOptions"
                      )
                    }}
                  </span>
                </div>
                <div
                  v-if="
                    report.json_content.installer_options !== null &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    typeof report.json_content.installer_options
                      .hub_question_value !== 'undefined' &&
                    report.json_content.installer_options.hub_question_value !==
                      null
                  "
                  class="mb-2"
                >
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.sentinelHub",
                        {
                          hubStatus: getHubStatus(
                            report.json_content.installer_options
                              .hub_question_value
                          ),
                        }
                      )
                    }}
                  </span>
                </div>
                <div
                  v-if="
                    report.json_content.installer_options !== null &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    typeof report.json_content.installer_options
                      .diag_skip_nmea !== 'undefined' &&
                    report.json_content.installer_options.diag_skip_nmea !==
                      null &&
                    report.json_content.installer_options.diag_skip_nmea
                  "
                  class="mb-2"
                >
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.nmeaSkipped"
                      )
                    }}
                  </span>
                </div>
                <div
                  v-if="
                    report.json_content.installer_options !== null &&
                    typeof report.json_content.installer_options !==
                      'undefined' &&
                    typeof report.json_content.installer_options
                      .diag_skip_fimrware_update !== 'undefined' &&
                    report.json_content.installer_options
                      .diag_skip_fimrware_update !== null &&
                    report.json_content.installer_options
                      .diag_skip_fimrware_update
                  "
                  class="mb-2"
                >
                  <span class="body-2 black--text">
                    {{
                      $t(
                        "components.miscellaneous.diagnosticsReports.firmwareSkipped"
                      )
                    }}
                  </span>
                </div>
              </div>

              <diagnostics-reports-entry
                class="ml-7 mt-2"
                v-for="(entry, ind) in report.json_content.report_sections"
                :key="ind"
                :report="entry"
              >
              </diagnostics-reports-entry>
            </v-list-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">
            {{ $t("components.miscellaneous.diagnosticsReports.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import api from "@/utils/api.js";
import DiagnosticsReportsEntry from "@/components/miscellaneous/DiagnosticsReportsEntry.vue";
export default {
  components: {
    DiagnosticsReportsEntry,
  },
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      reports: [],
    };
  },
  created() {
    this.getReports();
  },

  methods: {
    getReportSectionFieldTypes(reportSections) {
      if (reportSections.length === 0) return [];

      const sectionFields = reportSections.reduce((acc, curr) => {
        if (typeof curr.field_type === "undefined") return acc;
        acc[curr.field_type] = curr.field_type;
        return acc;
      }, {});

      return Object.keys(sectionFields);
    },

    getGroupedReportSectionsByFieldTypes(reportSections) {
      const sectionFieldsTypes =
        this.getReportSectionFieldTypes(reportSections);

      return reportSections.reduce((acc, curr) => {
        if (
          acc.findIndex((item) => curr.field_type === item.field_type) === -1
        ) {
          acc = [...acc, curr];
          return acc;
        }

        if (Object.keys(curr).includes("sensor_list")) {
          let index = acc.findIndex(
            (item) => curr.field_type === item.field_type
          );

          acc[index].sensor_list = [
            ...acc[index].sensor_list,
            ...curr.sensor_list,
          ];
        }

        return acc;
      }, []);
    },

    getHubStatus(value) {
      return value
        ? this.$t("components.miscellaneous.diagnosticsReports.present")
        : this.$t("components.miscellaneous.diagnosticsReports.notPresent");
    },

    getReports() {
      api.getReports(this.$route.params.id).then((resp) => {
        this.reports = resp.data.results.map((item) => {
          const groupedReportSectionsByFieldTypes =
            this.getGroupedReportSectionsByFieldTypes(
              item.json_content.report_sections
            );

          return {
            ...item,
            active: false,
            json_content: {
              ...item.json_content,
              report_sections: groupedReportSectionsByFieldTypes,
            },
          };
        });
      });
    },
    close() {
      this.$emit("close", true);
    },
  },
};
</script>
<style scoped></style>
